import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import { useSelectableDataCategoriesQuery } from "../../processingActivity/hooks/useSelectableDataCategoriesQuery.ts";

export interface SystemDataCategoriesCreationFieldProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    errorText?: string;
    disabled: boolean;
}

function SystemDataCategoriesCreationField(props: SystemDataCategoriesCreationFieldProps) {
    const { translateString } = useTranslation();
    const { allDataCategories, isLoading } = useSelectableDataCategoriesQuery();

    const options = allDataCategories?.map((item) => ({ id: item.id, name: item.name }));

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={options}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={translateString("dataCategories")}
            label={translateString("dataCategories")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemDataCategoriesCreationField;
